import { jsx as _jsx } from "react/jsx-runtime";
import { Subtitle } from '@/Components/Preferences/PreferencesComponents/Content';
import { observer } from 'mobx-react-lite';
import { c } from 'ttag';
const TwoFactorSuccess = () => (_jsx("div", { className: "flex flex-row items-center px-4 py-4", children: _jsx("div", { className: "flex flex-row items-center justify-center pt-2", children: _jsx(Subtitle, { children: c('B6.Preferences.Security.Info')
                .t `Two-factor authentication has been successfully enabled for your account.` }) }) }));
export default observer(TwoFactorSuccess);
